import { useUserWay } from '@/hooks/useUserWay';
import React from 'react';

export default function AccessibilityButton({ isDark }) {
  const { openWidget, loading } = useUserWay();

  return (
    <div
      onClick={openWidget}
      className={` ${!isDark ? 'bg-white' : 'bg-black'} transition-colors cursor-pointer w-8 h-8 lg:h-10 lg:w-10 flex flex-col items-center justify-center rounded-full`}
      aria-label="Open accessibility options"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        {/* Outer circle with optional spinner */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.3 : 1}
        />

        {/* Loading spinner arc */}
        {loading && (
          <path
            d="M10 1.25C14.8325 1.25 18.75 5.16751 18.75 10"
            stroke={isDark ? '#000' : '#FFF'}
            strokeWidth="1.25"
            strokeLinecap="round"
            fill="none"
            style={{
              transformOrigin: 'center',
              animation: 'spin 1s linear infinite',
            }}
          />
        )}

        {/* Head */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 4.58333C10.2301 4.58333 10.4167 4.39679 10.4167 4.16667C10.4167 3.93655 10.2301 3.75 10 3.75C9.76988 3.75 9.58333 3.93655 9.58333 4.16667C9.58333 4.39679 9.76988 4.58333 10 4.58333ZM10 5.83333C10.9205 5.83333 11.6667 5.08714 11.6667 4.16667C11.6667 3.24619 10.9205 2.5 10 2.5C9.07952 2.5 8.33333 3.24619 8.33333 4.16667C8.33333 5.08714 9.07952 5.83333 10 5.83333Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.5 : 1}
        />

        {/* Body */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 10.8333C9.65482 10.8333 9.375 10.5535 9.375 10.2083V7.29167C9.375 6.94649 9.65482 6.66667 10 6.66667C10.3452 6.66667 10.625 6.94649 10.625 7.29167V10.2083C10.625 10.5535 10.3452 10.8333 10 10.8333Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.5 : 1}
        />

        {/* Left leg */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.59165 16.1679C6.28511 16.0092 6.16524 15.6321 6.32391 15.3256L9.15764 9.85108C9.31632 9.54453 9.69345 9.42466 10 9.58333C10.3065 9.74201 10.4264 10.1191 10.2677 10.4257L7.43401 15.9002C7.27533 16.2067 6.8982 16.3266 6.59165 16.1679Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.5 : 1}
        />

        {/* Right leg */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4083 16.1679C13.7149 16.0092 13.8348 15.6321 13.6761 15.3256L10.8424 9.85108C10.6837 9.54453 10.3065 9.42466 10 9.58333C9.69345 9.74201 9.57358 10.1191 9.73226 10.4257L12.566 15.9002C12.7247 16.2067 13.1018 16.3266 13.4083 16.1679Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.5 : 1}
        />

        {/* Left arm */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.48492 6.89366C8.4012 7.22853 8.06187 7.43213 7.72699 7.34841L5.60634 6.81825C5.27147 6.73453 5.06787 6.3952 5.15158 6.06033C5.2353 5.72546 5.57464 5.52186 5.90951 5.60557L8.03016 6.13574C8.36504 6.21945 8.56864 6.55879 8.48492 6.89366Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.5 : 1}
        />

        {/* Right arm */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5151 6.89366C11.5988 7.22853 11.9381 7.43213 12.273 7.34841L14.3937 6.81825C14.7285 6.73453 14.9321 6.3952 14.8484 6.06033C14.7647 5.72546 14.4254 5.52186 14.0905 5.60557L11.9698 6.13574C11.635 6.21945 11.4314 6.55879 11.5151 6.89366Z"
          fill={!isDark ? '#000' : '#FFF'}
          opacity={loading ? 0.5 : 1}
        />

        {/* Add CSS animation */}
        <style>{`
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `}</style>
      </svg>
    </div>
  );
}
